import { render, staticRenderFns } from "./revt.vue?vue&type=template&id=6825ef77&scoped=true"
import script from "./revt.vue?vue&type=script&lang=js"
export * from "./revt.vue?vue&type=script&lang=js"
import style0 from "./revt.vue?vue&type=style&index=0&id=6825ef77&prod&lang=css"
import style1 from "./revt.vue?vue&type=style&index=1&id=6825ef77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6825ef77",
  null
  
)

export default component.exports